import React from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/hooks';
import { setSnackbarMessage } from 'src/store/snackbarMessage/snackbarSlice';
import styled from 'styled-components';

const Container = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 40px;
    z-index: 66666;
    left: 0;
    justify-content: center;
`;

const StyledSnackbar = styled.div`
    background: #000;
    bottom: 10px;
    width: 80%;
    max-width: calc(720px * 0.8);
    min-height: 40px;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 8px;
    z-index: 66666;
    white-space: pre-line;
`;

const SnackBar: React.FC = () => {
    const { errorMessage } = useAppSelector(state => state.snackbar);
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = React.useState(false);

    React.useEffect(() => {
        if (errorMessage.length > 0) {
            setIsOpen(true);
            setTimeout(() => {
                dispatch(setSnackbarMessage(''));
                setIsOpen(false);
            }, 2000);
        }
    }, [errorMessage]);

    return (
        <>
            {isOpen && (
                <Container>
                    <StyledSnackbar>{errorMessage}</StyledSnackbar>
                </Container>
            )}
        </>
    );
};

export default SnackBar;
